<template>
  <div>
    <div class="conections__user">
      <div class="title">
        <div class="div-title">
          <h4>{{translation.your_connections}}</h4>
        </div>
        <div class="tags">
          <div class="tag active">
            <span>{{translation.active}}</span>
          </div>
          <div class="tag disabled">
            <span>{{translation.inactive}}</span>
          </div>
          <div class="tag test">
            <span>{{translation.test}}</span>
          </div>
        </div>
      </div>
      <div class="body">
        <div class="body__in">
          <div
            class="card__user"
            v-for="(lead, index) in this.props"
            :key="index"
          >
            <img :src="lead.image">
            <div>
              <h5>{{lead.name}}</h5>
              <div class="status">
                <span
                  :class="'payment '+ lead.status.active"
                  :data-value="lead.status.active"
                >{{lead.status.label}}</span>
                <span
                  :class="'franchise '+ lead.franchise.type + ' ' + lead.franchise.active"
                  :data-value="lead.franchise.label"
                >{{lead.franchise.type}}</span>
              </div>
              <div class="tag__info active"></div>
            </div>
          </div>
          <!-- <div class="card__user">
            <img src="http://www.gravatar.com/avatar/0f2a1158acbfb27e2bfd4b58809e5259?s=80&d=mm&r=g">
            <div>
              <h5>Cassiano S1</h5>
              <div class="status">
                <span
                  class="payment inactive"
                  data-value="inactive"
                >Inativo</span>
                <span
                  class="franchise ambassador true"
                  data-value=""
                >Embaixador</span>
              </div>
            </div>
          </div> -->
        </div>
        <!-- <div>
          <div class="card__user">
            <img src="http://www.gravatar.com/avatar/0f2a1158acbfb27e2bfd4b58809e5259?s=80&d=mm&r=g">
            <div>
              <h5>Cassiano S1</h5>
              <div class="status">
                <span
                  class="payment inactive"
                  data-value="inactive"
                >Inativo</span>
                <span
                  class="franchise ambassador true"
                  data-value=""
                >Embaixador</span>
              </div>
            </div>
          </div>
          <div class="card__user">
            <img src="http://www.gravatar.com/avatar/0f2a1158acbfb27e2bfd4b58809e5259?s=80&d=mm&r=g">
            <div>
              <h5>Cassiano S1</h5>
              <div class="status">
                <span
                  class="payment inactive"
                  data-value="inactive"
                >Inativo</span>
                <span
                  class="franchise 2tier true"
                  data-value=""
                >2Tier</span>
              </div>
            </div>
          </div>
          <div class="card__user">
            <img src="http://www.gravatar.com/avatar/0f2a1158acbfb27e2bfd4b58809e5259?s=80&d=mm&r=g">
            <div>
              <h5>Cassiano S1</h5>
              <div class="status">
                <span
                  class="payment test"
                  data-value="test"
                >Teste</span>
                <span
                  class="franchise 2tier false"
                  data-value=""
                >2Tier</span>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
// import merge from 'lodash-es/merge';

export default {
  name: "connections-user",
  props: ["props"],
  components: {},
  data() {
    return {
      translation: this.$parent.$parent.view.translation.connectionsUser
    };
  },
  mounted() {
    // console.log(this.props);
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.conections__user {

  .title {
    display: flex;
    text-align: center;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;

    .div-title {
      width: 45px;
    }

    h4 {
      color: #818a91;
      margin: 0;
      font-weight: 300;
      font-size: 1.2rem;
    }
    .tags {
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      .tag {
        margin: 5px 0.5rem;
        background: #f8fafd;
        padding: 0.5rem 0.8rem 0.5rem 2.2rem;
        border-radius: 7px;
        position: relative;
        display: flex;
        align-self: center;
        &::after {
          content: "";
          position: absolute;
          top: 6px;
          left: 5px;
          width: 20px;
          height: 20px;
          border-radius: 50%;
        }
        &.active {
          &::after {
            background: #00fdc4;
          }
        }
        &.disabled {
          &::after {
            background: #ff5e5e;
          }
        }
        &.test {
          &::after {
            background: #fde400;
          }
        }
      }
    }
  }
  .body {
    padding: 1.4rem 0;
    .body__in {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .card__user {
        display: flex;
        align-items: center;
        padding: 0.3rem 1rem;
        border: 1px solid #eaeef0;
        border-radius: 7px;
        margin-bottom: 0.4rem;
        width: 45%;
        img {
          height: 50px;
          width: auto;
          border-radius: 50%;
          margin-right: 0.3rem;
        }
        h5 {
          margin: 0;
          color: #818a91;
        }
        .status {
          color: #fff;
          display: table;
          height: 16px;
          line-height: 16px;
          overflow: hidden;
          float: left;
          margin-top: 0.3rem;
          span {
            float: left;
            padding: 0 5px;
            font-size: 10px;
            font-weight: bold;
            text-transform: uppercase;
            border-radius: 16px;

            &.payment {
              transition: all 250ms ease-in;
              min-width: 16px;
              &:not(:hover) {
                font-size: 0;
              }
              &.active {
                background-color: #55efc4;
              }
              &.inactive {
                background-color: #ff7675;
              }
              &.test {
                background-color: #fdcb6e;
              }
            }
            &.franchise {
              margin-left: 5px;
              &[class~="2tier"] {
                background-color: #3f94f4;
              }
              &[class~="2tier-plus"] {
                background-color: #f5a723;
              }
              &[class~="ambassador"] {
                background-color: #00cec9;
              }
              &[class~="ambassador-plus"] {
                background-color: #00b894;
              }
              &[class~="founder"] {
                background-color: #ef5777;
              }
              &.false {
                background-color: #ced6e0;
              }
            }
          }
        }
      }
    }
  }
}
@media (max-width: 1300px) {
  .conections__user .body .body__in .card__user {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise/components/connectionsUser.vue